import React from "react";
import { ArgoCDFeedbackCallout } from "~/areas/infrastructure/components/ArgoCDInstances/ArgoCDFeedbackCallout";
type ActionChameleonAnchorProps = {
    actionTypes?: string[];
};
export function ActionSpecificArgoCallout({ actionTypes = [] }: ActionChameleonAnchorProps) {
    const argoCDActionTypes = ["Octopus.ArgoCD.ImageUpdate", "Octopus.ArgoCD.TemplateUpdate", "Octopus.ArgoCDUpdateImageTags", "Octopus.ArgoCDUpdateManifests"];
    const hasArgoCDActions = actionTypes.some((actionType) => argoCDActionTypes.includes(actionType));
    if (hasArgoCDActions) {
        return <ArgoCDFeedbackCallout />;
    }
    return null;
}
